<template>
    <div>
        <v-expansion-panel class="journey-events" expand v-model="expanded">
            <v-expansion-panel-content>
                <template v-slot:header>
                    <h2>Journey Events <badge class-name="badge--primary">{{ events.length }}</badge></h2>
                </template>

                <div class="journey-events__filters">
                    <div class="journey-events__filter">
                        <v-select
                            v-model="eventClassification"
                            :items="availableEventClassification"
                            label="Event classification"
                            class="small-field"
                            item-value="id"
                            item-text="key"
                            placeholder="Select event classification..."
                            outline
                            clearable
                            single-line
                            hide-details
                            multiple
                        ></v-select>
                    </div>

                    <div class="journey-events__filter">
                        <v-select
                            v-model="eventFilters"
                            :items="availableEventTypes"
                            label="Event type"
                            class="small-field"
                            item-value="id"
                            item-text="key"
                            placeholder="Select event type..."
                            outline
                            clearable
                            single-line
                            hide-details
                            multiple
                        ></v-select>
                    </div>
                </div>

                <div class="journey-events__list" v-if="events.length > 0">
                    <event-item
                        v-for="(event, index) in events"
                        v-show="event.isVisible"
                        :key="event.id"
                        :event="event"
                        :on-event-click="showEvent"
                        :driverInfo="false"
                    >
                    </event-item>
                </div>
                <plug v-else icon="question" title="No events have been found" :width="45" :height="55" color="#e2e2e2"></plug>

            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
import Badge from '@/components/atoms/Badge'
import EventItem from '@/components/atoms/EventItem'
import Plug from '@/components/atoms/Plug'

import { mapGetters } from 'vuex'

export default {
    name: 'JourneyEvents',
    components: { Badge, EventItem, Plug },
    props: {
        events: {
            type: Array,
            required: true
        }
    },
    data () {
        return {
            expanded: [true],
            filters: {
                eventClassifications: '',
                eventType: ''
            }
        }
    },
    watch: {
        eventFilters: {
            handler () {
                this.events.forEach((event) => {
                    event.isVisible = !!this.eventFilters.some(r => event.eventTypes.includes(r))
                })
            },
            deep: true
        },
        eventClassification: {
            handler () {
                this.events.forEach((event) => {
                    event.isVisible = !!this.eventClassification.includes(event.eventClassification)
                })
            },
            deep: true,
        }
    },
    computed: {
        ...mapGetters({
            eventTypes: 'dictionaryModule/getEventTypes',
            eventClassifications: 'dictionaryModule/getEventClassifications'
        }),
        availableEventTypes () {
            const availableCategories = [1, 2, 3, 5]
            return this.eventTypes.filter(event => availableCategories.includes(event.categoryId))
        },
        availableEventClassification () {
            const availableClassifications = [2, 3, 4]
            return this.eventClassifications.filter(event => availableClassifications.includes(event.id))
        },
        eventFilters: {
            get () {
                return this.$store.state.trackingModule.eventFilters
            },
            set (value) {
                this.$store.commit('trackingModule/setEventFilters', value)
            }
        },
        eventClassification: {
            get () {
                return this.$store.state.trackingModule.eventClassifications
            },
            set (value) {
                this.$store.commit('trackingModule/setEventClassification', value)
            }
        }
    },
    methods: {
        showEvent (payload) {
            this.$store.commit('setEventId', payload)
        },
    }
}
</script>

<style scoped lang="scss">
.journey-events {
    ::v-deep .v-text-field.v-text-field--placeholder input {
        margin-top: 0 !important;
    }

    &__filter {
        margin-bottom: 5px;
    }
}
</style>
